import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import ProtectedRoute from "./components/ProtectedRoute";
import HostRoute from "./components/HostRoute";
import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";
import ExperienceDetailPage from "./pages/ExperienceDetailPage";
import HostPage from "./pages/HostPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import DashboardPage from "./pages/DashboardPage";
import CreateEditExperiencePage from "./pages/CreateEditExperiencePage";
import MyBookingsPage from "./pages/MyBookingsPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import GuestProfilePage from "./pages/GuestProfilePage";
import AdminPage from "./pages/AdminPage";
import MessagesPage from "./pages/MessagesPage";
import ContentPage from "./pages/ContentPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import AboutPage from "./pages/AboutPage";
import HelpCenterPage from "./pages/HelpCenterPage";

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <NotificationProvider>
          <div className="App">
            <BrowserRouter>
            <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/experience/:id" element={<ExperienceDetailPage />} />
            <Route path="/host" element={<HostPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/page/:slug" element={<ContentPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/help" element={<HelpCenterPage />} />
            
            {/* Protected Routes - Any authenticated user */}
            <Route path="/my-bookings" element={
              <ProtectedRoute>
                <MyBookingsPage />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <GuestProfilePage />
              </ProtectedRoute>
            } />
            <Route path="/messages" element={
              <ProtectedRoute>
                <MessagesPage />
              </ProtectedRoute>
            } />
            
            {/* Host/Admin Only Routes */}
            <Route path="/dashboard" element={
              <HostRoute>
                <DashboardPage />
              </HostRoute>
            } />
            <Route path="/dashboard/create" element={
              <HostRoute>
                <CreateEditExperiencePage />
              </HostRoute>
            } />
            <Route path="/dashboard/edit/:id" element={
              <HostRoute>
                <CreateEditExperiencePage />
              </HostRoute>
            } />
            
            {/* Catch-all Route */}
            <Route path="*" element={<HomePage />} />
          </Routes>
          </BrowserRouter>
          </div>
        </NotificationProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
